import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18Cart2 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      transform: "translate(1 3)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M3.01 0c.36 0 .68.214.823.536l.04.112.392 1.342 9.507.001c.25.015.486.118.665.29l.085.091c.186.226.27.52.23.81l-.023.112L13.49 7.9l-.01.07a2.355 2.355 0 0 1-2.205 1.928H5.201a1.03 1.03 0 0 1-1.036-.8L2.779 3.29l-.005-.011-.038-.107L2.335 1.8H.9a.9.9 0 0 1-.893-.787L0 .9A.9.9 0 0 1 .787.007L.9 0zm9.721 3.79H4.749L5.777 8.1h5.368a.56.56 0 0 0 .552-.401l.044-.223z"
      }), /*#__PURE__*/jsx("circle", {
        cx: 6.57,
        cy: 11.69,
        r: 1
      }), /*#__PURE__*/jsx("circle", {
        cx: 10.76,
        cy: 11.69,
        r: 1
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Cart2$1 = Svg18Cart2;

export { Svg18Cart2$1 as default };
